import { gsap } from 'gsap/dist/gsap';
import { ScrollToPlugin } from 'gsap/all'
gsap.registerPlugin(ScrollToPlugin)

export default {
  init() {

    /**************************************************************
    -> Pageload animation
    **************************************************************/
    function pageNewsLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.75 })

      tl.to('.hero-news-and-press .wrap-fullscreen-image', { opacity: 1 })
      .to('.hero-news-and-press .dark-overlay-hero', { opacity: 1 }, '>-0.15')
      .to('.hero-news-and-press .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
      .to('.wrapper-news-and-press-page .wrap-search', { opacity: 1 }, '>-0.15')
    }
    pageNewsLoadAnimation()

    /**************************************************************
    -> News filters anim on scroll
    **************************************************************/
    function inViewAnimFilters() {
      gsap.fromTo('.wrapper-news-and-press-page .filter-title' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.wrapper-news-and-press-page .filters',
      })

      gsap.fromTo('.wrapper-news-and-press-page .wrap-sort-buttons' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.wrapper-news-and-press-page .filter-title',
      })
    }
    inViewAnimFilters();

    /**************************************************************
    -> News items anim on scroll
    **************************************************************/
    function inViewAnimNewsItems() {
      gsap.fromTo('.wrapper-news-and-press-page .news-list__card' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        stagger: {
          each: 0.08,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.wrapper-news-and-press-page .wrap-all-news-and-press',
      })
    }
    inViewAnimNewsItems();

    $(document).on('facetwp-refresh', function() {
      const buttonAll = document.querySelector('.sort-all');  
      const otherSortButton = Array.from(document.querySelectorAll('.facetwp-radio'));

      // if pager is clicked
      // gsap.to(window, {duration: 1, scrollTo: {y:'#news-and-press', offsetY: 100}});

      buttonAll.addEventListener('click', () => {
        buttonAll.classList.add('active');
      })

      otherSortButton.forEach(button => {

        button.addEventListener('click', () => {
          buttonAll.classList.remove('active');
        })

        if(button.classList.contains('checked')) {
          buttonAll.classList.remove('active');
        }
      })
    })

    $(document).on('facetwp-loaded', function() {
      // eslint-disable-next-line no-undef
      if (FWP.loaded) {
        $('html, body').animate({scrollTop: $('.facetwp-template').offset().top - 320}, 500);
      }
    });

    // eslint-disable-next-line no-undef
    FWP.loading_handler = function() { }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/news-and-press.js